import { useContext } from "react";
import {stateContext} from "../../App";

function Review() {
    const {setShowModal} = useContext(stateContext);
    return (
        <div className="flex justify-center items-center md:w-full backdrop-blur-[1px] bg-black/40 overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative my-6 flex mx-auto max-w-3xl">
                <div className="rounded-lg p-5 mt-2 mr-1  bg-white">
                    <div className="flex items-center justify-between gap-10">
                        <h1 className="font-bold text-2xl text-zinc-700">Your Campaign is begin reviewed</h1>
                        <button onClick={() => setShowModal(6)} className="pl-5 pr-5 pt-2 pb-2 bg-red-600 text-white rounded-2xl ">View Cart</button>
                    </div>
                    <div className="flex flex-col items-start">
                        <Point text="Lorem ipsum dolor sit amet, consectetur  "/>
                        <Point text="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Non,  "/>
                        <Point text="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Non, dicta? Accusamus  "/>                      
                        <Point text="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Non, dicta? Accusamus  "/>                        
                    </div>
                </div> 
                <div onClick={() => setShowModal(0)} className="flex justify-center items-center rounded-full bg-white h-5 w-5">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
            </div>   
            </div>
        </div>
    )
}

function Point({text}) {
    return (
        <div className="flex gap-2 justify-center items-center mt-3 text-xs text-zinc-500">
            <div className="h-4 w-4 rounded-full bg-green-800 flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="white">
                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                </svg>
            </div>
            <div>{text}</div>
        </div>
    )
}


export default Review;